import {sample} from 'lodash';
import {useMemo} from 'react';

import {useUserTheme} from '../../../libs/shared/ui/src/theme/userThemeProvider';
import {findThemedImageInfo, ThemedImageNamesEnum} from '../../helpers/imageThemeHelpers';

/*
 * Constants.
 */

const inboxNoConversationsImages = [
  ThemedImageNamesEnum.INBOX_NO_CONVERSATIONS_1,
  ThemedImageNamesEnum.INBOX_NO_CONVERSATIONS_2,
  ThemedImageNamesEnum.INBOX_NO_CONVERSATIONS_3,
];

/*
 * Hooks.
 */

export const useNoConversationsImageSrc = () => {
  const theme = useUserTheme();

  return useMemo(
    () => findThemedImageInfo(theme, sample(inboxNoConversationsImages) ?? inboxNoConversationsImages[0]).src,
    [theme],
  );
};
